__turbopack_context__.v({
  "message": "PdfViewer-module-scss-module__-_wcKG__message",
  "navBtn": "PdfViewer-module-scss-module__-_wcKG__navBtn",
  "navNext": "PdfViewer-module-scss-module__-_wcKG__navNext",
  "navPrev": "PdfViewer-module-scss-module__-_wcKG__navPrev",
  "page": "PdfViewer-module-scss-module__-_wcKG__page",
  "pageLabel": "PdfViewer-module-scss-module__-_wcKG__pageLabel",
  "slide": "PdfViewer-module-scss-module__-_wcKG__slide",
  "spinnerWrapper": "PdfViewer-module-scss-module__-_wcKG__spinnerWrapper",
  "toolbar": "PdfViewer-module-scss-module__-_wcKG__toolbar",
  "toolbarBtn": "PdfViewer-module-scss-module__-_wcKG__toolbarBtn",
  "toolbarControls": "PdfViewer-module-scss-module__-_wcKG__toolbarControls",
  "toolbarTitle": "PdfViewer-module-scss-module__-_wcKG__toolbarTitle",
  "track": "PdfViewer-module-scss-module__-_wcKG__track",
  "viewport": "PdfViewer-module-scss-module__-_wcKG__viewport",
  "wrapper": "PdfViewer-module-scss-module__-_wcKG__wrapper",
  "zoomControls": "PdfViewer-module-scss-module__-_wcKG__zoomControls",
  "zoomLabel": "PdfViewer-module-scss-module__-_wcKG__zoomLabel",
  "zoomed": "PdfViewer-module-scss-module__-_wcKG__zoomed",
});
